export default __webpack_public_path__ + "static/media/taraz.359609e6.png";